module.exports = " <section class=\"text__footer mb20\"> <div class=container> <div class=col-md-12> <span class=text-justify ng-bind-html=\"$ctrl.responseText | toTrusted\"></span> </div> </div> </section>";


/*****************
 ** WEBPACK FOOTER
 ** ./www/components/box-text-template/templates/box-text-template-base.html
 ** module id = 608
 ** module chunks = 7
 **/